import React, {useEffect, useState} from "react";
import axios from "axios";
import {colors, sizes} from "../../utils/styled/_variables.styled";
import Input from "../FormComponents/Input/Input";
import Icon from "../Icon/Icon";
import {InfiosSearchNavigation, InfiosSearchSuggestions, InfiosSearchWrapper} from "./SearchNavigation.style";
import {InfiosContainer} from "../../utils/styled/_grid.style";
import Link from "../Link/Link";
import Button from "../Button/Button";
import {urlHasParam} from "../../utils/js/params";
import {ErrorBoundary} from "react-error-boundary";

const SearchNavigation = (props) => {

    const { className, headerVersion, iconVersion, placeholder, showSuggestions, showPopular, color, resultsPage, blackLetter, isFullWidth, isMobile } = props;

    const [icon, setIcon] = useState("search");
    const fullVersion = !iconVersion;
    const [value, setValue] = useState("");
    const [openSearch, setOpenSearch] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [popularTerms, setPopularTerms] = useState([]);

    useEffect(() => {
        if (value.length > 0) {
            setIcon("cancel");
        } else {
            setIcon("search");
        }
    }, [value]);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const q = urlParams.get("q");
        if (q) {
            setValue(q);
            setSuggestions([]);
        }
    }, []);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const q = urlParams.get("q");
        if (value.length > 2 && value !== q) {
            axios.get(`${props.cqPath}.infios-suggestion.json?term=${value}&mode=suggest`)
                .then(response => {
                    setSuggestions(response.data);
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }, [value]);

    const search = (ev) => {
        setValue(ev.target.value);
    }

    const clearSearch = () => {
        setValue("");
    }

    const openSearchBox = () => {
        setOpenSearch(true);
    }

    const closeSearchBox = () => {
        setOpenSearch(false);
    }

    const handleSearch = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            window.location.href = `${resultsPage}?q=${value}${urlHasParam('wcmmode=disabled') ? '&wcmmode=disabled' : ''}`;
        }
    };

    const staticSearchsContent = () => {
        if ((!suggestions.length && !popularTerms.length) || (!showSuggestions && !showPopular)) {
            return null;
        }

        const searchList = suggestions.length ? suggestions : popularTerms;

        return (
            <>
                <span className="label-medium">{suggestions.length ? "Suggested Searches" : "Popular Search"}</span>
                <ul>
                    {searchList.map((search, index) => (
                        <li key={`search-${index}`}>
                            <Link noIcon className="search-container-link" link={`${resultsPage}?q=${search}${urlHasParam('wcmmode=disabled') ? '&wcmmode=disabled' : ''}`}>
                                <div className="search-link">
                                    <Icon className="search" onClick={openSearchBox} icon="search" color={color ? color : colors.infiosGray} />
                                    <div className="search-link__text">{search}</div>
                                </div>
                            </Link>
                        </li>
                    ))}
                </ul>
            </>
        );
    }

    return (
        <InfiosSearchWrapper isMobile={isMobile} icon={icon} fullVersion={fullVersion} headerVersion={headerVersion} isFullWidth={isFullWidth} className={"search-component"}>
            <InfiosSearchNavigation className={className} isMobile={isMobile} >
                {(headerVersion || fullVersion) && (
                    <div className="suggestions-wrapper">
                        <Input
                            placeholder={placeholder || "Enter your search term"}
                            value={value}
                            icon={icon}
                            iconHandler={clearSearch}
                            validate={setValue}
                            changeHandler={search}
                            onKeyPress={handleSearch}
                            className="lead"
                            type="text"
                            name="search-navigation"
                        />
                        {(showSuggestions || showPopular) && (
                            <InfiosSearchSuggestions headerVersion={headerVersion}>
                                {staticSearchsContent()}
                            </InfiosSearchSuggestions>
                        )}
                    </div>
                )}
                {!headerVersion && !fullVersion && !isMobile && (
                    <Icon
                        className="search"
                        onClick={openSearchBox}
                        icon="search"
                        color={(blackLetter === "whiteBlack" || blackLetter === "transparentBlack") ? colors.infiosGray : colors.white}
                    />
                )}
            </InfiosSearchNavigation>

            {!isMobile && openSearch && (
                <InfiosContainer>
                    <Button className="close" onClick={() => closeSearchBox()} tertiary icon="close" />
                    {!headerVersion && !fullVersion && (
                        <Input
                            placeholder={placeholder || "Enter your search term"}
                            value={value}
                            icon={icon}
                            iconHandler={clearSearch}
                            validate={setValue}
                            changeHandler={search}
                            className="lead"
                            onKeyPress={handleSearch}
                            type="text"
                            name="search-navigation"
                        />
                    )}
                    {(showSuggestions || showPopular) && (
                        <InfiosSearchSuggestions>
                            {staticSearchsContent()}
                        </InfiosSearchSuggestions>
                    )}
                </InfiosContainer>
            )}
        </InfiosSearchWrapper>
    );
};

const SearchNavigationHandleErrors = props => {
    return (
        <ErrorBoundary fallback={props.isInEditor || urlHasParam('wcmmode=disabled') ? <div style={{minHeight: '50px', display: 'flex', alignItems: 'center', backgroundColor: '#ffe1db'}}><p>The search navigation component is currently experiencing errors. Please try again later.</p></div> : <div></div>}>
            <SearchNavigation {...props}/>
        </ErrorBoundary>
    )
  }

export default SearchNavigationHandleErrors;
